import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

declare var $: any;

@Injectable()
export class ModalService {
    private show: boolean = false;
    public modalProcessingServiceSubject = new Subject<boolean>();
    public modalNotFoundServiceSubject = new Subject<boolean>();
    public modalErrorServiceSubject = new Subject<boolean>();

    constructor() {

    }
    public showProcessingModal() {
        this.show = true;
        this.modalProcessingServiceSubject.next(true);
    }
    public hideProcessingModal() {
        this.show = false;
        this.modalProcessingServiceSubject.next(true);
    }
    public showErrorModal() {
        this.show = true;
        this.modalErrorServiceSubject.next(true);
    }
    public hideErrorModal() {
        this.show = false;
        this.modalErrorServiceSubject.next(true);
    }
    public showNotFoundModal() {
        this.show = true;
        this.modalNotFoundServiceSubject.next(true);
    }
    public hideNotFoundModal() {
        this.show = false;
        this.modalNotFoundServiceSubject.next(true);
    }
    public isShow(): boolean {
        return this.show;
    }
    public setShow(show:boolean) {
        this.show = show;
    }
    ngOnInit() {

    }
}
